import {makeStyles} from "tss-react/mui";

export const useRexAITrustedAdvisorStyles = makeStyles()((theme) => ({
  drawer: {
    width: 280,
    flexShrink: 0,
    "@media print": {
      display: "none",
    },
  },
  drawerPaper: {
    width: 280,
    position: "relative",
    borderRight: 1,
    borderColor: "divider",
    overflowY: "auto",
    scrollbarColor: "transparent transparent",
    "&:hover": {
      scrollbarColor: "auto",
    },
  },
  messageListBox: {
    width: "80%",
    "@media print": {
      width: "100%",
    },
  },
  conversationLayout: {
    display: "flex",
    height: "calc(100vh - 100px + var(--top-bar-offset, 0px))",
    "@media print": {
      display: "block",
      height: "auto",
      overflow: "visible",
    },
  },
  conversation: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    overflow: "auto",
    "@media print": {
      display: "block",
      overflow: "visible",
    },
  },
  messageListArea: {
    flex: 1,
    minHeight: 0,
    position: "relative",
    display: "flex",
    flexDirection: "column",
    "@media print": {
      display: "block",
    },
  },
  jumpToLatest: {
    position: "absolute",
    bottom: theme.spacing(2),
    left: "50%",
    transform: "translateX(-50%)",
    zIndex: 1,
    borderRadius: theme.spacing(2),
    textTransform: "none",
    "@media print": {
      display: "none",
    },
  },
  messageList: {
    flex: 1,
    overflow: "auto",
    overscrollBehavior: "contain",
    padding: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    scrollbarWidth: "thin",
    "@media print": {
      overflow: "visible",
      height: "auto",
      display: "block",
    },
  },
  messageListError: {
    padding: theme.spacing(1),
    width: "80%",
    margin: "0 auto",
    boxSizing: "border-box",
    overflowWrap: "anywhere",
  },
  formBox: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    padding: theme.spacing(2),
    "@media print": {
      display: "none",
    },
  },
  formBoxColumn: {
    display: "flex",
    flexDirection: "column",
    width: "80%",
    margin: "0 auto",
  },
  chipArea: {
    display: "flex",
    flexWrap: "wrap",
    gap: 4,
  },
  formBoxWrapper: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    width: "100%",
  },
  sessionList: {
    paddingTop: 0,
    paddingBottom: 0,
    flex: 1,
    overflowY: "auto",
  },
  sessionListContainer: {
    height: "100%",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
  },
  selectModeBar: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0, 1),
  },
  sessionListItem: {
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5),
    paddingRight: theme.spacing(1),
  },
  infoIcon: {
    marginLeft: theme.spacing(0.5),
    fontSize: "1rem",
  },
  trademark: {
    verticalAlign: "super",
  },
  earlyAccessLabel: {
    display: "flex",
    fontWeight: 600,
    justifyContent: "center",
  },
  sessionItemPrimary: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(0.5),
  },
  sessionBadge: {
    marginLeft: "-12px",
    marginRight: "4px",
  },
  sessionRenameField: {
    flex: 1,
  },
  sessionName: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    flex: 1,
  },
  sessionMenuButton: {
    marginLeft: theme.spacing(0.5),
  },
  sessionMenuButtonHidden: {
    visibility: "hidden",
  },
  sessionMenuIcon: {
    color: theme.palette.text.secondary,
  },
  menuItemError: {
    color: theme.palette.error.main,
  },
  deleteIcon: {
    marginLeft: theme.spacing(1),
    color: theme.palette.text.secondary,
  },
  deleteIconConfirming: {
    marginLeft: theme.spacing(1),
    color: theme.palette.error.main,
  },
  stopGeneration: {
    alignSelf: "center",
  },
  sharingDialogLoading: {
    paddingTop: theme.spacing(1),
  },
  sharingDialogLoadingHeading: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(1),
  },
  sharingDialogLoadingRow: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(1, 0),
  },
  sharingDialogLoadingAvatar: {
    marginRight: theme.spacing(2),
  },
  sharingDialogLoadingText: {
    flex: 1,
  },
  sharingDialogSection: {
    marginTop: theme.spacing(2),
  },
  sharingDialogHistoryDivider: {
    marginBottom: theme.spacing(2),
  },
  sharingDialogHistory: {
    maxHeight: theme.spacing(30),
    overflowY: "auto",
    paddingRight: theme.spacing(0.5),
    scrollbarWidth: "thin",
  },
}));
